import monogramWhiteUrl from "@/assets/brand/maky/monogram_white.svg";
import monogramUrl from "@/assets/brand/maky/monogram.svg";
import mascotHeadUrl from "@/assets/brand/maky/mascot_head.svg";
import mascotUrl from "@/assets/brand/maky/mascot.svg";

// ponytail: <img> instead of inline SVG — no svgr dep, and the adherence
// checker forbids raw hex in .tsx, which inline brand SVGs would carry.
// Recoloring is done by shipping the variant files the brand board defines.

type MarkVariant = "default" | "white";

/** m-체크 모노그램. 헤더·로그인·파비콘 등 기능형 자리에 쓴다. */
export function MakyMonogram({
  size = 28,
  variant = "default",
  className,
}: {
  size?: number;
  variant?: MarkVariant;
  className?: string;
}) {
  return (
    <img
      src={variant === "white" ? monogramWhiteUrl : monogramUrl}
      alt=""
      aria-hidden
      width={size}
      height={Math.round((size * 220) / 240)}
      className={className}
    />
  );
}

/** 막냉이 캐릭터. 저밀도 화면(로그인·빈 상태·완료)에만. 16px 이하 금지. */
export function MakyMascot({
  size = 120,
  head = false,
  className,
}: {
  size?: number;
  head?: boolean;
  className?: string;
}) {
  return (
    <img
      src={head ? mascotHeadUrl : mascotUrl}
      alt=""
      aria-hidden
      width={size}
      height={head ? size : Math.round((size * 260) / 240)}
      className={className}
    />
  );
}

/** 심볼 + maky 워드마크 가로 락업. */
export function MakyLockup({
  size = 32,
  variant = "default",
  className,
}: {
  size?: number;
  variant?: MarkVariant;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ""}`}>
      <MakyMonogram size={size} variant={variant} />
      {/* ponytail: 보드는 워드마크에 Poppins 를 지정하지만, 글자 4개 때문에
          웹폰트를 하나 더 받지 않는다. --font-sans 의 Pretendard 라틴으로 충분. */}
      <span className="font-extrabold leading-none tracking-tight" style={{ fontSize: size }}>
        maky
      </span>
    </span>
  );
}
